//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function () {
  const curalate = angular.module('curalate');

  curalate.component('distributionSearchFilter', {
    bindings: {
      uniqueKey: '@?',
      isRightAligned: '<',
    },
    template: require('@legacy-components/filters/distribution-search-filter.html'),
    require: {
      searchFilterSet: '^searchFilterSet',
    },
    controller: [
      '$scope',
      '$timeout',
      'CONTENT',
      'FanreelService',
      'SearchFilterService',
      'SessionVarsService',
      function (
        $scope,
        $timeout,
        CONTENT,
        FanreelService,
        SearchFilterService,
        SessionVarsService,
      ) {
        const self = this;
        const DISTRIBUTION = CONTENT.DISTRIBUTION;
        self.distributionFilter = self.uniqueKey || DISTRIBUTION;
        const IS_DISTRIBUTED = CONTENT.IS_DISTRIBUTED;
        const isDistributedFilter = self.uniqueKey
          ? `${IS_DISTRIBUTED}-${self.uniqueKey}`
          : IS_DISTRIBUTED;

        $scope.model = {
          isLike2BuyEnabled: SessionVarsService.isFeatureEnabled('like2buy'),
          isSchedulerEnabled: SessionVarsService.isFeatureEnabled(
            'instagram_scheduler',
          ),
          isRevealEnabled:
            SessionVarsService.isFeatureEnabled('reveal_page') ||
            SessionVarsService.isSyndicationClient(),
          isTributaryEnabled: SessionVarsService.isFeatureEnabled(
            'tributary_self_serve',
          ),
          fanreelsName: SessionVarsService.isFeatureEnabled('galleries')
            ? 'Galleries'
            : 'Fanreel',
        };

        $scope.model.distributionDropdownChanged = function (newValue) {
          $scope.model.isDistributed = newValue;

          if (newValue === null && $scope.model.distribution) {
            // If changing to 'not specified' and distribution options are set, clear them
            SearchFilterService.clearFiltersForKeys(self.searchFilterSet.name, [
              self.distributionFilter,
              isDistributedFilter,
            ]);
          } else if ($scope.model.distribution) {
            self.searchFilterSet.updateFilter(isDistributedFilter, [
              $scope.model.isDistributed,
            ]);
          }
        };

        this.$onInit = function () {
          const getReelsParams = {
            noStats: true,
            includeModeratedCanvases: false,
          };

          FanreelService.getReelsAsync(getReelsParams).then((reels) => {
            $scope.model.reels = _(reels).map((reel) => ({
              id: reel.id,
              name: reel.name || reel.id,
            }));
          });

          const initialIsDistributedState = _(
            self.searchFilterSet.getFilterState(),
          ).safeGet(`${isDistributedFilter}.0`);
          if (initialIsDistributedState) {
            $scope.model.initialDistributedState = initialIsDistributedState;
            $scope.model.isDistributed = initialIsDistributedState;
          }

          SearchFilterService.getObservableForFilterSet(
            self.searchFilterSet.name,
          ).subscribe((setUpdate) => {
            const currentIsDistributedState =
              _(setUpdate).safeGet(`setObject.${isDistributedFilter}.0`) ||
              null;
            $scope.model.distribution = _(setUpdate).safeGet(
              `setObject.${self.distributionFilter}.0`,
            );

            if (
              $scope.model.distribution &&
              $scope.model.isDistributed &&
              currentIsDistributedState !== $scope.model.isDistributed
            ) {
              // If there are distribution options checked and no 'isDistributed' API parameter, set 'isDistributed' in the search filter set
              self.searchFilterSet.updateFilter(isDistributedFilter, [
                $scope.model.isDistributed,
              ]);
            } else if (
              !$scope.model.distribution &&
              currentIsDistributedState
            ) {
              // Clear the 'isDistributed' API param if there are no distribution options checked
              self.searchFilterSet.updateFilter(isDistributedFilter, []);
            }
          });

          if (self.searchFilterSet.isSetLoadable) {
            self.isLoading = true;
            self.searchFilterSet.loadingStateObservable.subscribe(
              (isSetLoading) => {
                self.isLoading = isSetLoading;
              },
            );
          } else {
            self.isLoading = false;
          }
        };
      },
    ],
  });
})();
